module.exports = __webpack_public_path__ + "media/images/common/close_btn-b6d366641385a72b10f2870f1b5ac1e9.png";